export default __webpack_public_path__ + "static/media/sbb.1bab34a6.png";